<template>
  <div class="box-container">
    <d-header
      :breadcrumbs="false"
      fluid
    >
      <h1 class="title is-4">
        <d-previous-btn
          :path="'/properties/' + $route.params.property + '/statuses'"
        />
        {{ $t("details").capitalize() }}
      </h1>
    </d-header>

    <d-container
      style="max-width: 600px;"
    >
      <show-property-status-details
        :status="model"
        :property="model.property"
        mode="show"
      />
    </d-container>
  </div>
</template>

<script>

import ShowPropertyStatusDetails from "../property/components/ShowPropertyStatusDetails.vue";

export default {
  components: {
    "show-property-status-details": ShowPropertyStatusDetails,
  },
  metaInfo() {
    return {
      title: this.title,
      __property_status: this.title, // for breadcrumb
    };
  },
  data() {
    return {
      model: {},
      loading: true,
    };
  },
  computed: {
    title() {
      if (this.model) {
        return this.$t(this.model.type).capitalize();
      }
      return "";
    },
  },
  created() {
    this.loading = true;
    this.$http
      .get(
        this.$laravel.route("api.property-statuses.show", {
          property: parseInt(this.$route.params.property),
          property_status: this.$route.params.propertyStatus,
        })
      )
      .then((response) => {
        this.loading = false;
        this.model = response.data.data;
      })
      .catch((e) => {
        console.error(e);
        this.$router.push("/properties");
      });
  },
};
</script>
